const createPasteFilesPlugin: any = (handleImagePaste: (files: File[]) => void) => {
  return {
    handlePastedFiles: (files: File[]) => {
      handleImagePaste(files);
      return 'handled';
    }
  };
};
export default createPasteFilesPlugin;
